"use client";

import { GlobalHttpErrorPage } from "@workspace/ui/components/global-http-error-page";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <GlobalHttpErrorPage error={error} logContext={{ app: "platform-app" }} reset={reset} />;
}
